import * as React from 'react';
import api from '@/lib/api';
import { VIEWS } from '@/constants/views';
import { useRole } from '@/hooks/use-role';


const AuthContext = React.createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const [view, setView] = React.useState(VIEWS.VIEW_LOADING);
  const [loading, setLoading] = React.useState(true);
  const [detalhe, setDetalhe] = React.useState(null);
  const { roleCheck } = useRole();



  function getToken() {
    const user = localStorage.getItem("secretaria_user")

    if (!user) {
      setView(VIEWS.VIEW_LOGIN)
      setLoading(false)
      return
    }

    let user_json

    try {
      user_json = JSON.parse(user)
    } catch {
      setView(VIEWS.VIEW_LOGIN)
      setLoading(false)
      return
    }

    if (!user_json || (typeof user_json === 'object' && Object.keys(user_json).length === 0)) {
      setView(VIEWS.VIEW_LOGIN)
      setLoading(false)
      return
    }

    setUser(user_json)
    api.defaults.headers.common['Authorization'] = `Bearer ${user_json.token}`
    setView(VIEWS.VIEW_DASH)
    setLoading(false)

  }

  function handleSignout() {
    setUser(null)
    localStorage.removeItem('secretaria_user')
    setView(VIEWS.VIEW_LOGIN)
  }

  function handleDetalhe(id) {
    setDetalhe(id);
    setView(VIEWS.VIEW_DETALHE);
    window.history.pushState({ view: VIEWS.VIEW_DETALHE }, "");
  }


  React.useEffect(() => {
    const timeout = setTimeout(() => {
      getToken();
    }, 1400);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setView, view, handleSignout, setUser, detalhe, handleDetalhe, setDetalhe }}>
      {(loading || !roleCheck) ? (
        <div className="flex items-center justify-center h-screen">
          <img src="/logo.png" alt="logo" className="h-[35px] animate-pulse" />
        </div>
      ) : (
        children
      )
      }
    </AuthContext.Provider>
  );
};

export function useAuth() {
  const context = React.useContext(AuthContext)
  return context
}